module.exports = __webpack_public_path__ + "img/HAQQ.b6d88824.png";